/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

// project imports
import store from "features/store";
import { bgTransparantBlack } from "shared/images/images";

// style imports
import './NotificationModal.scss';
import { connect } from "react-redux";
import { cookiesPolicy } from "shared/settings/config";


/* this will be shown after sigin as a notification alert */
class NotificationModal extends Component {

    handleClose = () => store.dispatch({ type: 'TOGGLE_NOTIFICATION_MODAL', payload: {
        show: false, navigateData: null
    }});

    render() {
        return (
            <Modal id="notification-modal-main"
                show={this.props.toggleNotificationModal.show} onHide={this.handleClose} 
                animation={false} centered
                size="md" className=" animate__animated animate__fadeInUp"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Body>
                    <div className="register-close-icon">
                        <div className="close-icon-1 clickable" onClick={this.handleClose}></div>
                    </div>

                    <div className="d-flex flex-column align-items-center">
                        <img src="/static/logo/CTBids_logo.png" alt="logo" width="250px" />
                    </div>

                    {/* add props.user.paymentCompleted condition if multiple notifications are used */}
                    <div className="text-container text-justify">
                        <p>Welcome back to CTBids! </p>
                        <p>Our Process has changed where we require all customers to secure a payment method to bid. Please select 'Go to My Profile' below to update your personal information and add a payment method. </p>
                    </div>
                    <div className="d-flex flex-column text-center text-info mb-3">
                        <Link to="/my-account/my-info/personal-info">
                            <b onClick={this.handleClose}><u>Go to My Profile</u></b>
                        </Link>
                        <span className="my-2 clickable" onClick={this.handleClose}><u>Skip this step for now</u></span>
                    </div>
                    <div className="text-center mb-3 pb-2">
                        By using our website you are consenting to our use of
                        <span className="break-line"> cookies in accordance with <span className="external-link clickable text-info underline"><a href={cookiesPolicy} target="_blank" >cookie policy</a></span></span>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
};

export default connect(state => state)(NotificationModal);